import { z } from "zod";

export interface ProductionZoneListEntity {
  id: number;
  nombre: string;
  zonaComercial: string;
  activo: boolean;
}

export interface ProductionZonesListResponse {
  listado: ProductionZoneListEntity[];
  totalRecords: number;
  totalPages: number;
  page: number;
  pageSize: number;
}

export const productionZonesFilterSchema = z.object({
  Nombre: z.string().optional(),
  ZonaComercial: z.any().optional(),
  Activo: z.any().optional(),
});
